// src/pages/ModuleLibraryPage.jsx
// Phase 1 scope: this business's own genuinely-built modules, not a cross-business
// catalog - that needs new access-control design as its own future task (no cross-tenant
// query capability or admin/superadmin gate exists anywhere today to build on). App.js
// already filters `modules` down to completionStatus.routes && completionStatus.database
// before passing them in, so everything rendered here is real, not a placeholder scaffold.
import { theme, rgba } from '../theme';

export default function ModuleLibraryPage({ modules, onOpen }) {
  return (
    <div style={{ padding: '48px', minHeight: '100vh' }}>
      <h1 style={{ color: '#e2e8f0', fontSize: '28px', marginBottom: '8px' }}>Module Library</h1>
      <p style={{ color: theme.colors.textOnPageBackground, fontSize: '16px', marginBottom: '32px' }}>
        Real, built modules for this business. Ask Aetheris to build a new one from chat.
      </p>

      {modules.length === 0 ? (
        <div style={{
          padding: '32px',
          background: rgba(theme.colors.tileBackgroundRgb, 0.8),
          border: `1px solid ${rgba(theme.colors.tileBorderRgb, 0.3)}`,
          borderRadius: '12px',
          color: theme.colors.textOnPageBackground,
        }}>
          No built modules yet - anything currently in progress will show up here once it's genuinely working (real database and API routes, not a placeholder scaffold).
        </div>
      ) : (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '20px' }}>
          {modules.map(module => (
            <div key={module.id} style={{
              padding: '24px',
              background: rgba(theme.colors.tileBackgroundRgb, 0.8),
              border: `1px solid ${rgba(theme.colors.tileBorderRgb, 0.3)}`,
              borderRadius: '12px',
            }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '8px' }}>
                <h3 style={{ color: '#e2e8f0', fontSize: '18px', margin: 0 }}>{module.name}</h3>
                <span style={{
                  background: 'rgba(34, 197, 94, 0.3)',
                  padding: '2px 6px',
                  borderRadius: '4px',
                  fontSize: '10px',
                  color: '#22c55e',
                }}>
                  AI
                </span>
              </div>
              <p style={{ color: theme.colors.textOnPageBackground, fontSize: '14px', marginBottom: '20px' }}>
                {module.description}
              </p>
              <button
                onClick={() => onOpen(module.id)}
                style={{
                  padding: '10px 20px',
                  background: `linear-gradient(135deg, ${theme.colors.primary}, ${theme.colors.accent})`,
                  border: 'none',
                  borderRadius: '8px',
                  color: theme.colors.textOnPrimary,
                  fontSize: '14px',
                  fontWeight: '600',
                  cursor: 'pointer',
                }}
              >
                Open
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
